const EMPLOYER_PILOT_MAILTO =
  "mailto:admin@vacwork.app?subject=Employer%20onboarding%20request";

export function EmployerPilotLoginCallout() {
  return (
    <div className="w-full border-border border-b bg-secondary text-foreground">
      <div className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 px-4 py-2 text-center text-xs sm:text-sm">
        <span>Hiring?</span>
        <a
          className="underline underline-offset-2 transition-colors hover:text-foreground/80"
          href={EMPLOYER_PILOT_MAILTO}
          rel="noopener noreferrer"
          target="_blank"
        >
          Contact us
        </a>
        <span>to set up an account.</span>
      </div>
    </div>
  );
}
